export default __webpack_public_path__ + "static/media/man.cecf8719.svg";